export default {"src":"/_next/static/media/stressMotivationMobile.1bee5a2d.svg","height":232,"width":272,"blurWidth":0,"blurHeight":0};